import * as React from 'react';
import IconSvg from './check_24px.svg';
import './completeIcon.module.scss';
export const CompleteIcon = ({ styleName = undefined, className = undefined }) => (
    <div styleName="complete-icon" className={className}>
        <img styleName="icon" src={IconSvg} />
    </div>
);
